import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getApiData } from '../../../services/index';
import { useSearchParams } from 'react-router-dom';

const Blogs = () => {

  const [blogs, setBlogs] = useState([]);
  const [searchParams] = useSearchParams();

  const checkData = () => {
    console.log("checkData");
    let tags = searchParams.get('tag');

    const app = {};
    app.tag = (tags) ? tags : '';
    
    getApiData("api/get_blog_list", app).then((result) => {
      let responseJson = result;
      console.log("result: ", result);
      if (responseJson && result["status"] === 200) {
        console.log("data: ", result["data"].length);
        setBlogs(result["data"]);
      }
    });
  };

  useEffect(() => {
    checkData();
  }, []);

  return (
    <>
      <div class="section">
        <div class="container">
          <div>
            <div class="w-dyn-list">
              <div role="list" class="blog-list w-dyn-items">
                {blogs.length > 0 ? blogs.map((blog, index) => (
                  <div role="listitem" class="w-dyn-item">
                    <div data-w-id="51765b5c-319d-492e-fb5f-277220cb4556" class="blog-main w-clearfix">
                      <Link
                        style={{ backgroundImage: `url(${blog.image})` }}
                        to={`/BlogDetails/${blog.slug}`}
                        class="blog-thumbnail w-inline-block">
                      </Link>
                      <div class="bottom-part">
                        <div class="category-text">{blog.date}</div>
                        <h3 class="blog-title">{blog.name}</h3>
                        <div class="margin-20px">
                          <div class="button-flex-category">
                            <Link
                              to={`/BlogDetails/${blog.slug}`}
                              className="button-underline w-inline-block">
                              <div className="button-color">Read more</div>
                              <div className="line-animation">
                                <div className="underline"></div>
                              </div>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )) : (
                  <p>No blogs available at the moment.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  )
}

export default Blogs